import React from 'react';

export const ZipComponent = ({ descargados, totales, porcentaje }) => {
	return (
		<div
			style={{
				marginTop: '30px',
				padding: '20px',
				backgroundColor: '#f4f4f4',
				border: '1px solid #ccc',
				borderRadius: '8px',
				textAlign: 'center',
			}}
		>
			<h2
				style={{
					fontSize: '20px',
					marginBottom: '10px',
					color: '#333',
				}}
			>
				Carpeta Electronica
			</h2>

			<h3
				style={{
					fontSize: '16px',
					fontWeight: 'normal',
					color: '#666',
					marginBottom: '20px',
				}}
			>
				Descargando archivos {descargados} de {totales}
			</h3>

			<div
				style={{
					width: '100%',
					height: '10px',
					backgroundColor: '#e0e0e0',
					borderRadius: '10px',
					overflow: 'hidden',
				}}
			>
				<div
					style={{
						width: `${porcentaje}%`,
						height: '100%',
						backgroundColor: '#3699FF',
						transition: 'width 0.3s ease-in-out',
					}}
				></div>
			</div>

			<div
				style={{
					marginTop: '8px',
					fontSize: '14px',
					color: '#444',
				}}
			>
				{porcentaje}% completado
			</div>
			<div
				style={{
					marginTop: '12px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					gap: '8px',
				}}
			>
				<div
					style={{
						width: '16px',
						height: '16px',
						border: '2px solid #3699FF',
						borderTop: '2px solid transparent',
						borderRadius: '50%',
						animation: 'spin 1s linear infinite',
					}}
				></div>
				<span style={{ color: '#555', fontSize: '14px' }}>
					Procesando archivos...
				</span>
			</div>
		</div>
	);
};
